<div class="p-box">
  <div class="p-box-1">
    <ion-header>
      <ion-toolbar mode="ios">
        <ion-title>{{ title }}</ion-title>
        <ion-buttons>
          <ion-button slot="icon-only" (click)="closeModal()">
            <ion-icon name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button fill="solid" color="primary" size="small" (click)="validate()">
            <ion-icon name="checkmark"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
  </div>
  <div class="p-box-1">
    <ion-row class="ion-justify-content-center" *ngIf="canSetMarkers && canDraw">
      <ion-button (click)="modeMarqueur()" size="small" [disabled]="mode === 'marqueurs'">
        Ajouter des marqueurs
      </ion-button>
      <ion-button (click)="modeDessin()" size="small" [disabled]="mode === 'dessin'">
        Dessiner
      </ion-button>
    </ion-row>
    <ion-row class="ion-justify-content-center ion-align-items-center" style="min-height: 54px;">
      <!-- options marqueurs -->
      <ng-container *ngIf="mode === 'marqueurs'">
        <ion-button (click)="addMarqueur()" size="small" [disabled]="limitNbMarqueur !== undefined && (limitNbMarqueur <= marqueurs.length)">
          Ajouter un marqueur
        </ion-button>
        <ion-button [disabled]="!(marqueurs.length > 0)" *ngIf="marqueurs.length > 0" (click)="removeMarqueurs()" size="small" color="danger">
          Retirer les marqueurs
        </ion-button>
      </ng-container>
      <!-- options dessin -->
      <ng-container *ngIf="mode === 'dessin'">
        <ion-button [disabled]="!(dessin | isNotEmptyStringPipe)" *ngIf="dessin | isNotEmptyStringPipe" (click)="clearDessin()" size="small" color="danger">
          Effacer le dessin
        </ion-button>
        <ion-button (click)="onBackToPreviousValueButtonClick()" color="danger" *ngIf="dessinHistory.length > 1">
          <ion-icon slot="icon-only" name="return-down-back-outline"></ion-icon>
        </ion-button>
        <ion-button (click)="onChangeDrawingmodeClick('drawing')" [color]="dessinMode === 'drawing' ? 'success' : 'primary'" class="ion-margin-start">
          <ion-icon slot="icon-only" name="pencil-outline"></ion-icon>
        </ion-button>
        <ion-button (click)="onChangeDrawingmodeClick('rectangle')" [color]="dessinMode === 'rectangle' ? 'success' : 'primary'">
          <ion-icon slot="icon-only" name="square-outline"></ion-icon>
        </ion-button>
        <ion-button (click)="onChangeDrawingmodeClick('ellipse')" [color]="dessinMode === 'ellipse' ? 'success' : 'primary'">
          <ion-icon slot="icon-only" name="ellipse-outline"></ion-icon>
        </ion-button>
        <ion-button (click)="onChangeDrawingmodeClick('line')" [color]="dessinMode === 'line' ? 'success' : 'primary'">
          <ion-icon slot="icon-only" name="remove-outline" class="c-rotate-icon"></ion-icon>
        </ion-button>
      </ng-container>
      <ng-container *ngIf="mode === undefined">
        <ion-button size="small" style="visibility: hidden;">
          Test
        </ion-button>
      </ng-container>
    </ion-row>
    <ng-container>
    </ng-container>
  </div>
  <div class="p-box-2" #BoxContainer>
    <ng-container *ngIf="imgMaxHeight">
      <ng-container *ngIf="mode === 'marqueurs'">
        <!--
        <app-c-elements-marqueurs *ngIf="marqueurs" [startingDatas]="marqueurs" [addMarqueurTrigger$]="addMarqueurTrigger$" [deleteMarqueursTrigger$]="deleteMarqueursTrigger$" [resizedWindowTrigger$]="resizedWindowTrigger$" [cannotMoveMarkers]="!canSetMarkers" [marqueurSize]="marqueurSize" (communicateFinalDatas)="reevaluateFinalDataMarqueurs($event)">
          <ng-container *ngIf="imageDataBase64; else CadreIfNoImage">
            <img [src]="imageDataBase64" alt="" class="c-image" [ngStyle]="{'height': imgMaxHeight}">
          </ng-container>
        </app-c-elements-marqueurs>
        -->
        <app-c-elements-marqueurs *ngIf="marqueurs" [startingDatas]="marqueurs" [addMarqueurTrigger$]="addMarqueurTrigger$" [deleteMarqueursTrigger$]="deleteMarqueursTrigger$" [resizedWindowTrigger$]="resizedWindowTrigger$" [cannotMoveMarkers]="!canSetMarkers" [marqueurSize]="marqueurSize" [limitNbMarqueur]="limitNbMarqueur" (communicateFinalDatas)="reevaluateFinalDataMarqueurs($event)">
          <app-c-drawing-canvas *ngIf="dessin !== undefined" [resizedWindowTrigger$]="resizedWindowTrigger$" [initialDatas]="dessin" [overWriteSubject$]="overwritePadDessin$" [clearPadGeometric$]="clearPadGeometric$" [canDraw]="false" [marqueurSize]="0" (triggerAlert)="reevaluateFinalDataDessin($event)" [mode]="dessinMode">
            <ng-container *ngIf="imageDataBase64; else CadreIfNoImage">
              <img [src]="imageDataBase64" alt="" class="c-image" [ngStyle]="{'height': imgMaxHeight}">
            </ng-container>
          </app-c-drawing-canvas>
        </app-c-elements-marqueurs>
      </ng-container>
      <ng-container *ngIf="mode === 'dessin'">
        <!--
        <app-c-drawing-canvas *ngIf="dessin !== undefined" [resizedWindowTrigger$]="resizedWindowTrigger$" [initialDatas]="dessin" [overWriteSubject$]="overwritePadDessin$" [canDraw]="canDraw" [marqueurSize]="marqueurSize" (triggerAlert)="reevaluateFinalDataDessin($event)" >
          <ng-container *ngIf="imageDataBase64; else CadreIfNoImage">
            <img [src]="imageDataBase64" alt="" class="c-image" [ngStyle]="{'height': imgMaxHeight}">
          </ng-container>
        </app-c-drawing-canvas>
        -->
        <app-c-elements-marqueurs *ngIf="marqueurs" [startingDatas]="marqueurs" [addMarqueurTrigger$]="addMarqueurTrigger$" [deleteMarqueursTrigger$]="deleteMarqueursTrigger$" [resizedWindowTrigger$]="resizedWindowTrigger$" [cannotMoveMarkers]="true" [marqueurSize]="marqueurSize" [limitNbMarqueur]="limitNbMarqueur" (communicateFinalDatas)="reevaluateFinalDataMarqueurs($event)">
          <app-c-drawing-canvas *ngIf="dessin !== undefined" [resizedWindowTrigger$]="resizedWindowTrigger$" [initialDatas]="dessin" [overWriteSubject$]="overwritePadDessin$" [clearPadGeometric$]="clearPadGeometric$" [canDraw]="canDraw" [marqueurSize]="0" (triggerAlert)="reevaluateFinalDataDessin($event)" [mode]="dessinMode">
            <ng-container *ngIf="imageDataBase64; else CadreIfNoImage">
              <img [src]="imageDataBase64" alt="" class="c-image" [ngStyle]="{'height': imgMaxHeight}">
            </ng-container>
          </app-c-drawing-canvas>
        </app-c-elements-marqueurs>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="mode === undefined">
      <!--
      <app-c-elements-marqueurs *ngIf="marqueurs" [startingDatas]="marqueurs" [addMarqueurTrigger$]="addMarqueurTrigger$" [deleteMarqueursTrigger$]="deleteMarqueursTrigger$" [resizedWindowTrigger$]="resizedWindowTrigger$" [cannotMoveMarkers]="true" [marqueurSize]="marqueurSize" (communicateFinalDatas)="reevaluateFinalDataMarqueurs($event)">
        <app-c-drawing-canvas *ngIf="dessin !== undefined" [resizedWindowTrigger$]="resizedWindowTrigger$" [initialDatas]="dessin" [overWriteSubject$]="overwritePadDessin$" [canDraw]="false" [marqueurSize]="0" (triggerAlert)="reevaluateFinalDataDessin($event)" >
          <ng-container *ngIf="imageDataBase64; else CadreIfNoImage">
            <img [src]="imageDataBase64" alt="" class="c-image" [ngStyle]="{'height': imgMaxHeight}">
          </ng-container>
        </app-c-drawing-canvas>
      </app-c-elements-marqueurs>
      -->
      <app-c-elements-marqueurs *ngIf="marqueurs" [startingDatas]="marqueurs" [addMarqueurTrigger$]="addMarqueurTrigger$" [deleteMarqueursTrigger$]="deleteMarqueursTrigger$" [resizedWindowTrigger$]="resizedWindowTrigger$" [cannotMoveMarkers]="true" [marqueurSize]="marqueurSize" [limitNbMarqueur]="limitNbMarqueur" (communicateFinalDatas)="reevaluateFinalDataMarqueurs($event)">
        <app-c-drawing-canvas *ngIf="dessin !== undefined" [resizedWindowTrigger$]="resizedWindowTrigger$" [initialDatas]="dessin" [overWriteSubject$]="overwritePadDessin$" [clearPadGeometric$]="clearPadGeometric$" [canDraw]="false" [marqueurSize]="0" (triggerAlert)="reevaluateFinalDataDessin($event)" [mode]="'drawing'">
          <ng-container *ngIf="imageDataBase64; else CadreIfNoImage">
            <img [src]="imageDataBase64" alt="" class="c-image" [ngStyle]="{'height': imgMaxHeight}">
          </ng-container>
        </app-c-drawing-canvas>
      </app-c-elements-marqueurs>
    </ng-container>
    <img [src]="imageDataBase64" alt="" class="c-image-invisible" #ImageReferenceRatio>
  </div>
  <ng-template #CadreIfNoImage>
    <div class="c-cadre" #cadre [ngStyle]="{'height': cadreMaxHeight}"></div>
  </ng-template>

  <div class="p-box-3">
    <ng-container *ngIf="field?.fields?.markers as fieldMarqueurs">
      <app-c-sketch-legende [fieldMarqueurs]="fieldMarqueurs" [sourceMarqueurs]="marqueurs" (modifiedValue)="editMarqueurInfo($event)" [modeShow]="false"></app-c-sketch-legende>
    </ng-container>
  </div>
</div>